const crossIcon = `
<svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
    <title>Path</title>
    <desc>Created with Sketch.</desc>
    <g id="Mailing" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Mailings---Mailing---Edit" transform="translate(-1073.000000, -427.000000)" fill="#979797" fill-rule="nonzero">
            <g id="Group-9" transform="translate(309.000000, 239.000000)">
                <g id="Group-8" transform="translate(1.000000, 39.000000)">
                    <g id="Group-14" transform="translate(663.000000, 138.000000)">
                        <polygon id="Path" points="109.415 12.414 108 11 104.708 14.293 101.415 11 100 12.414 103.293 15.707 100 19 101.415 20.414 104.708 17.122 108 20.414 109.415 19 106.122 15.707"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export default crossIcon;
